export default {
  GET_CONFIG_REQUEST: 'client/config/request',
  GET_CONFIG_SUCCESS: 'client/config/success',
  GET_CONFIG_FAILURE: 'client/config/failure',
}
